export default __webpack_public_path__ + "static/media/ic_calendar_title.3d3fcd80.svg";